'use client';

import { createContext, useContext } from 'react';

export const DeviceContext = createContext<boolean>(false);

export function useIsMobile(): boolean {
  return useContext(DeviceContext);
}
